import React from 'react';
import { AdvancedMarker } from '@vis.gl/react-google-maps';
import StopMarker from '../../images/stop.jsx';
import './Marker.scss';

const Marker = ({ style, position, active, onToggle, type, weatherData }) => {
  return (
    <AdvancedMarker
      position={position}
      className={`marker ${active ? 'active' : ''}`}
      zIndex={active ? 2 : 1}
      onClick={onToggle}
    >
      <StopMarker type={type} style={style} weatherData={weatherData} />
    </AdvancedMarker>
  );
};

export default Marker;
